// Next Diamonds — Cart promo code apply (AJAX, no page reload)
//
// Flow:
//   1. POST blocked → fetch /discount/CODE (silently follows the 302 redirect)
//   2. Section-render API fetches updated cart-drawer + main-cart HTML
//   3. We swap the cart-form innerHTML in place — drawer stays open,
//      totals update, the green "Coupon X applied" pill appears.

(function () {
  'use strict';

  function showStatus(form, msg, tone) {
    var status = form.querySelector('[data-cart-promo-status]');
    if (!status) return;
    status.textContent = msg;
    status.classList.add('is-visible');
    status.style.color = tone === 'error' ? '#B73E3E' : '';
    // Red outline on the field while the error message shows
    form.classList.toggle('is-error', tone === 'error');
  }

  async function refreshCartSections() {
    // IMPORTANT: /cart?sections=... returns cart JSON (not section HTML)
    // because Shopify intercepts /cart requests. Use the section render API
    // from any non-cart URL — root works fine.
    var url = '/?sections=cart-drawer,main-cart&_=' + Date.now();
    var res = await fetch(url, {
      headers: { Accept: 'application/json', 'Cache-Control': 'no-cache' },
      credentials: 'same-origin'
    });
    if (!res.ok) throw new Error('HTTP ' + res.status);
    var data = await res.json();
    var parser = new DOMParser();

    // Swap cart-drawer innards
    if (data['cart-drawer']) {
      var doc = parser.parseFromString(data['cart-drawer'], 'text/html');
      var newForm = doc.querySelector('cart-drawer cart-form, side-drawer cart-form, cart-form');
      var oldForm = document.querySelector('cart-drawer cart-form, side-drawer cart-form');
      if (newForm && oldForm) {
        oldForm.innerHTML = newForm.innerHTML;
      }
    }

    // Swap cart-page form (if user is on /cart)
    if (data['main-cart']) {
      var pageDoc = parser.parseFromString(data['main-cart'], 'text/html');
      var newPageForm = pageDoc.querySelector('cart-form');
      var oldPageForm = document.querySelector('.template-cart cart-form');
      if (newPageForm && oldPageForm) {
        oldPageForm.innerHTML = newPageForm.innerHTML;
      }
    }

    // Re-fire init events for any embedded JS (sale countdown, autogrow, etc.)
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  // Coupon Remove — Shopify's documented way to clear all applied discount
  // codes via AJAX: POST /cart/update.js with `discount: ''` (empty string).
  // (Ref: https://shopify.dev/docs/api/ajax/reference/cart — discount field)
  //
  // BUGFIX: previously the selector was `.sum-promo__remove` but the actual
  // class in cart-promo.liquid is `.sum-promo__btn--remove`, so this handler
  // never matched. The <a> click then navigated to `/discount/clear` which
  // is NOT a real Shopify endpoint, leaving the discount stuck.
  document.addEventListener('click', async function (e) {
    var removeBtn = e.target.closest(
      '[data-cart-promo-remove], .sum-promo__btn--remove, .sum-promo__remove'
    );
    if (!removeBtn) return;
    e.preventDefault();
    e.stopPropagation();

    // Disable the button visually while clearing
    removeBtn.disabled = true;
    var originalText = removeBtn.textContent;
    removeBtn.textContent = 'Removing…';

    try {
      // 1) Shopify's AJAX path — clears all discount codes from the session.
      var res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: '' }),
        credentials: 'same-origin'
      });
      if (!res.ok) throw new Error('cart/update.js HTTP ' + res.status);

      // Also expire the storefront discount cookie so a fresh checkout does
      // not silently re-attach a code the customer just removed.
      try {
        document.cookie = 'discount_code=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
      } catch (e) {}

      // 2) Verify the discount is actually gone — Shopify sometimes silently
      //    ignores the discount field. If so, fall back to a form post to /cart.
      var cartCheck = await fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
      var stillApplied = (cartCheck.discount_codes || []).some(function (d) { return d.applicable; });

      if (stillApplied) {
        // Fallback: a form post to /cart with discount_code= (empty) is the
        // legacy storefront pattern that mirrors what /cart's <form> does.
        var fd = new FormData();
        fd.append('discount_code', '');
        await fetch('/cart', {
          method: 'POST',
          body: fd,
          credentials: 'same-origin',
          headers: { 'Accept': 'text/html' }
        });
      }

      await refreshCartSections();
    } catch (err) {
      console.error('[ND cart] coupon remove failed:', err);
      removeBtn.textContent = originalText;
      removeBtn.disabled = false;
      // Final fallback — full reload so the customer is never stuck
      try { sessionStorage.setItem('nd-cart-reopen', '1'); } catch (e2) {}
      window.location.reload();
    }
  }, true);

  // Apply — triggered by the Apply button or Enter in the code field. The
  // promo row is a div (a nested form gets dropped on the cart page), so
  // there is no submit event; Enter is intercepted so the page's cart form
  // is never submitted by it.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target;
    if (!input || !input.matches || !input.matches('[data-cart-promo-form] input[name="code"]')) return;
    e.preventDefault();
    e.stopPropagation();
    var btn = input.closest('[data-cart-promo-form]').querySelector('[data-cart-promo-btn]');
    if (btn && !btn.disabled) btn.click();
  }, true);

  document.addEventListener('click', async function (e) {
    var clicked = e.target.closest ? e.target.closest('[data-cart-promo-btn]') : null;
    if (!clicked) return;
    var form = clicked.closest('[data-cart-promo-form]');
    if (!form) return;
    e.preventDefault();
    e.stopPropagation();

    var input = form.querySelector('input[name="code"]');
    if (!input) return;
    var code = (input.value || '').trim();
    if (!code) return;

    var btn = form.querySelector('[data-cart-promo-btn]');
    if (btn) btn.disabled = true;
    showStatus(form, 'Applying…');

    try {
      // Set the discount on the session. Fetch follows the 302 silently.
      var discountRes = await fetch('/discount/' + encodeURIComponent(code), {
        method: 'GET',
        credentials: 'same-origin'
      });
      console.log('[ND cart] /discount/' + code + ' →', discountRes.status, discountRes.url);

      // FIRST: peek at the cart state to determine the outcome. We only do
      // the full section refresh on a real success — otherwise the form gets
      // replaced and our error status would have nowhere to render.
      var cartState = {};
      try {
        cartState = await fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
      } catch (e) {}

      var codeUpper = code.toUpperCase();
      var codes = (cartState.discount_codes || []);
      var matched = null;
      for (var i = 0; i < codes.length; i++) {
        if ((codes[i].code || '').toUpperCase() === codeUpper) { matched = codes[i]; break; }
      }
      // Collect every discount-application title currently affecting the cart
      // (cart-level + line-level). If the entered code appears here, Shopify
      // recognised it (even if it didn't end up applying); if NOT, the code
      // is truly unknown to Shopify regardless of the discount_codes entry.
      var allDiscountTitles = {};
      var items = cartState.items || [];
      for (var j = 0; j < items.length; j++) {
        var allocs = items[j].line_level_discount_allocations || [];
        for (var k = 0; k < allocs.length; k++) {
          var t = (allocs[k].discount_application && allocs[k].discount_application.title) || '';
          if (t) allDiscountTitles[t.toUpperCase()] = true;
        }
      }
      (cartState.cart_level_discount_applications || []).forEach(function (da) {
        if (da && da.title) allDiscountTitles[da.title.toUpperCase()] = true;
      });
      var hasActiveAutomatic = false;
      Object.keys(allDiscountTitles).forEach(function (t) {
        if (t !== codeUpper) hasActiveAutomatic = true;
      });
      // Code is "recognised" if Shopify created a discount application for it
      // (visible somewhere in cart/line allocations) — even if applicable:false.
      var codeRecognised = !!allDiscountTitles[codeUpper];

      // Shopify's own behavior when combinations are off:
      //   - If the entered code gives a BIGGER discount than the active sale,
      //     Shopify replaces the sale with the code → applicable:true
      //   - If the code gives the SAME or a LOWER discount, the existing sale
      //     stays and the code is marked applicable:false
      //   - If the code is invalid, it never appears in cart.discount_codes
      // From the cart JSON alone we can't distinguish a "valid but blocked"
      // code from an "unknown" code (both end up in discount_codes with
      // applicable:false and neither shows up in discount_applications). We
      // prefer the forgiving message when an automatic sale is active.
      var msg = 'Invalid code', tone = 'error', hideAfter = 2600, isSuccess = false;
      if (matched && matched.applicable) {
        msg = 'Applied ✓'; tone = ''; hideAfter = 1800; isSuccess = true;
      } else if (hasActiveAutomatic) {
        msg = 'Current sale gives a better discount';
        hideAfter = 3200;
      } else if (matched) {
        msg = 'Code doesn’t apply to this cart';
        hideAfter = 3200;
      }
      // else: no active sale AND code unknown to Shopify → genuinely invalid

      // Show the status on the CURRENT form (still alive) BEFORE any
      // potential section refresh that would replace it.
      showStatus(form, msg, tone);
      if (!isSuccess && btn) btn.disabled = false;

      if (isSuccess) {
        // On success, refresh sections so the applied pill renders. The form
        // itself gets replaced, but the message had time to flash.
        await refreshCartSections();
      } else {
        // On failure, keep the form, just fade the status after a few seconds.
        setTimeout(function () {
          var s = form.querySelector('[data-cart-promo-status]');
          if (s) s.classList.remove('is-visible');
          form.classList.remove('is-error');
        }, hideAfter);
      }
    } catch (err) {
      console.error('[ND cart] coupon apply failed:', err);
      showStatus(form, 'Could not apply', 'error');
      if (btn) btn.disabled = false;
    }
  }, true); // capture phase
})();
